<seo-head></seo-head>
<debug></debug>
<alert-list></alert-list>
<header></header>
<router-outlet></router-outlet>
<footer></footer>
<ng-container #bottomMenu></ng-container>
